<nz-table
    #basicTable
    [nzData]="data"
    [nzLoading]="loading"
    [nzScroll]="{ y: '500px' }"
    [nzFrontPagination]="false"
    [nzTotal]="totalRows"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    (nzPageIndexChange)="onPageChange($event)"
    [nzShowTotal]="totalTemplate"
>
    <thead>
        <tr>
            <th nzLeft nzWidth="250px">Sub Category</th>
            <th>Planned Options</th>
            <th>Options</th>
            <th>SKU's</th>
            <th>CP</th>
            <th>RRP</th>
            <th>Price Inc %</th>
            <th>Weighted Margin %</th>
            <th>Planned buy units</th>
            <th>Total Unit Sales</th>
            <th>Confirm PO Units</th>
            <th>PO Sell Thru</th>
            <th>Extnd Risk Value @ Cost</th>
            <th>Extnd Risk Value @ Whsl</th>
            <th>Extnd Retail Sales Value</th>
            <th nzWidth="130px">Total Extnd Whsl Value</th>
            <th nzWidth="130px">Extnd PO Value</th>
            <th nzWidth="130px">Budget</th>
            <th nzWidth="130px">Var to bud</th>
            <th>% SOB</th>
            <th>Plan SOB%</th>
            <th>SKU Efficiency</th>
            <th>Plan unit sales</th>
            <th nzWidth="130px">Plan wholesale value</th>
            <th>Plan GP%</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngIf="data && totals" class="totals-row">
            <td nzLeft class="totals-cell">Total</td>
            <td class="totals-cell">{{ formatNumber(totals.plannedOptions) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.options) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.skuPlan) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.wholesalePrice) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.suggestedRetailPrice) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.priceIncrease) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.weightedMargin) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.originalPlannedUnits) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.totalUnitSales) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.confirmedPurchaseOrderUnits) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.purchaseOrderSellThrough) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.extendedRiskValueCost) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.extendedRiskValueAtWholesale) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.extendedRetailSalesValue) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.totalExtendedWholesaleValue) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.extendedPurchaseOrderValue) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.budget) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.variance) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.shareOfBusinessPercentage) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.plannedShareOfBusiness) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.skuEfficiency) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.plannedUnitSales) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.plannedWholesaleValue) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.plannedGrossPricePercentage) }}</td>
        </tr>
        <tr *ngFor="let item of basicTable.data">
            <td nzLeft>{{ item.subCategoryId }}</td>
            <td>{{ formatNumber(item.plannedOptions) }}</td>
            <td>{{ formatNumber(item.options) }}</td>
            <td>{{ formatNumber(item.skuPlan) }}</td>
            <td>{{ formatCurrency(item.wholesalePrice) }}</td>
            <td>{{ formatCurrency(item.suggestedRetailPrice) }}</td>
            <td>{{ formatPercentage(item.priceIncrease) }}</td>
            <td>{{ formatPercentage(item.weightedMargin) }}</td>
            <td>{{ formatNumber(item.originalPlannedUnits) }}</td>
            <td>{{ formatNumber(item.totalUnitSales) }}</td>
            <td>{{ formatNumber(item.confirmedPurchaseOrderUnits) }}</td>
            <td>{{ formatPercentage(item.purchaseOrderSellThrough) }}</td>
            <td>{{ formatCurrency(item.extendedRiskValueCost) }}</td>
            <td>{{ formatCurrency(item.extendedRiskValueAtWholesale) }}</td>
            <td>{{ formatCurrency(item.extendedRetailSalesValue) }}</td>
            <td>{{ formatCurrency(item.totalExtendedWholesaleValue) }}</td>
            <td>{{ formatCurrency(item.extendedPurchaseOrderValue) }}</td>
            <td>{{ formatCurrency(item.budget) }}</td>
            <td>{{ formatCurrency(item.variance) }}</td>
            <td>{{ formatPercentage(item.shareOfBusinessPercentage) }}</td>
            <td>{{ formatPercentage(item.plannedShareOfBusiness) }}</td>
            <td>{{ formatPercentage(item.skuEfficiency) }}</td>
            <td>{{ formatNumber(item.plannedUnitSales) }}</td>
            <td>{{ formatCurrency(item.plannedWholesaleValue) }}</td>
            <td>{{ formatPercentage(item.plannedGrossPricePercentage) }}</td>
        </tr>
    </tbody>
</nz-table>

<ng-template #totalTemplate let-total>
    Total {{ total }} items
</ng-template>
